import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { oneResultFrom } from '@vendasta/rx-utils';
import { PipelineFilterSaverService } from '../../pipeline-filters-cache/pipeline-filter-saver.service';

@Component({
  selector: 'sales-ui-pipeline-table-filter-dialog',
  templateUrl: './pipeline-filter-dialog.component.html',
  styles: [
    `
      glxy-alert {
        margin-bottom: 16px;
      }
    `,
  ],
})
export class PipelineFilterDialogComponent {
  filterGroupName: string;
  isDuplicate = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: { savedFilterGroupNames: string[] },
    private readonly filterStorage: PipelineFilterSaverService,
    private readonly snackbarService: SnackbarService,
    private readonly translateService: TranslateService,
  ) {}

  checkIsDuplicate(): void {
    this.isDuplicate = this.data.savedFilterGroupNames.includes(this.filterGroupName);
  }

  async saveFilterGroup(): Promise<void> {
    const successMessage = await oneResultFrom(
      this.translateService.stream('FRONTEND.SALES_UI.PIPELINE.SAVE_FILTER_SUCCESS'),
    );

    this.filterStorage
      .deleteFilterGroup(this.filterGroupName)
      .then(() => this.filterStorage.saveCurrentFilters(this.filterGroupName))
      .then((err) => {
        if (err) {
          return this.snackbarService.openErrorSnack(err.message);
        }

        this.snackbarService.openSuccessSnack(successMessage);
      });
  }
}
